<template>
  <!-- Use general search from parent component -->
  <!-- In-active (Out) Principals -->
  <div class="bin-workspace">
    <div
      class="card z-depth-0 bin-record"
      v-for="enrollee in inactivePrincipals"
      :key="enrollee.id"
    >
      <div class="card-content">
        <div class="record-grid">
          <div class="record-avatar">
            <img
              :src="enrollee.profile_img"
              width="96"
              class="circle responsive-img"
              v-if="enrollee.profile_img"
            />
            <img
              :src="`https://ui-avatars.com/api/?name=${enrollee.name}&color=FFFFFF&size=128`"
              width="96"
              class="circle responsive-img"
              v-else
            />
          </div>

          <div class="record-main">
            <label class="active teal-text">Principal</label>
            <h6>
              <s>{{ enrollee.name }}</s>
              <small v-if="enrollee.enrollee_number">({{ enrollee.enrollee_number }})</small>
            </h6>
          </div>

          <div class="record-meta">
            <label>Plan</label>
            <strong>{{ enrollee.plan?.name || "No plan" }}</strong>
          </div>

          <div class="record-meta">
            <label>Type</label>
            <strong>{{ enrollee.type == "f" ? "Family" : "Individual" }}</strong>
          </div>

          <div class="record-meta">
            <label>Family</label>
            <strong>{{ familyCount(enrollee) }} member(s)</strong>
          </div>

          <div class="record-actions">
            <a href="#" @click.prevent="handleMenu({ type: 'status', value: enrollee })">
              <i class="material-icons tiny left">{{ isOpen(enrollee, "status") ? "close" : "restore" }}</i>
              {{ isOpen(enrollee, "status") ? "Close" : "Restore" }}
            </a>
            <a
              href="#"
              class="red-text text-darken-2"
              @click.prevent="handleMenu({ type: 'kill', value: enrollee })"
              v-if="hasActiveAccess(enrollee)"
            >
              <i class="material-icons tiny left">{{ isOpen(enrollee, "kill") ? "close" : "block" }}</i>
              {{ isOpen(enrollee, "kill") ? "Close" : "Block Access" }}
            </a>
          </div>
        </div>
      </div>

      <!-- Restore -->
      <div class="bin-action-panel" v-if="action == 'status' && currId == enrollee.id">
        <EnrolleeStatusDiv
          :enrollee="enrollee"
          @reset="handleReset"
        />
      </div>

      <!-- Block access -->
      <div class="bin-action-panel" v-if="action == 'kill' && currId == enrollee.id">
        <KillAccountDiv
          :enrollee="enrollee"
          @reset="handleReset"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import EnrolleeStatusDiv from "@/components/client/onboard/EnrolleeStatusEditOnboardComponent.vue";
import KillAccountDiv from "@/components/client/onboard/EnrolleeKillAccountOnboardComponent.vue";

export default {
  name: "PrincipalOutClientComponent",
  components: {
    EnrolleeStatusDiv,
    KillAccountDiv,
  },
  props: ["cat", "enrollees"],
  emits: ["reset"],
  setup(props, context) {
    const action = ref(null);
    const currId = ref(null);

    const inactivePrincipals = computed(() => {
      return (props.enrollees || []).filter((enrollee) => enrollee.status == "d");
    });

    const familyCount = (enrollee) => {
      const spouseCount = enrollee.spouse && enrollee.spouse.status != "d" ? 1 : 0;
      const dependantCount = (enrollee.dependants || []).filter((dependant) => dependant.status != "d").length;
      return 1 + spouseCount + dependantCount;
    };

    const hasActiveAccess = (enrollee) => {
      return Number(enrollee.active_access_count || 0) > 0;
    };

    const isOpen = (enrollee, selectedAction) => {
      return action.value == selectedAction && currId.value == enrollee.id;
    };

    // clear all
    const clearAll = () => {
      action.value = null;
      currId.value = null;
    };

    // handle menu
    const handleMenu = (val) => {
      if (action.value == val.type && currId.value == val.value.id) {
        clearAll();
        return;
      }

      clearAll();
      action.value = val.type;
      currId.value = val.value.id;
    };

    // handle
    const handleReset = (val) => {
      context.emit("reset", val);
      clearAll();
    };

    return {
      handleReset,
      handleMenu,
      familyCount,
      hasActiveAccess,
      isOpen,
      inactivePrincipals,
      action,
      currId,
    };
  },
};
</script>

<style scoped>
.bin-workspace {
  margin-top: 8px;
}

.bin-record {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-shadow: none;
}

.record-main h6 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.bin-record {
  margin-bottom: 14px;
}

.record-grid {
  align-items: center;
  display: grid;
  gap: 16px;
  grid-template-columns: 104px minmax(220px, 1fr) minmax(140px, 180px) minmax(100px, 130px) minmax(110px, 140px) minmax(160px, auto);
}

.record-avatar img {
  display: block;
}

.record-main small {
  color: #607d8b;
  font-weight: 500;
  margin-left: 6px;
}

.record-meta label {
  color: #607d8b;
  display: block;
  font-size: 0.78rem;
}

.record-meta strong {
  color: #263238;
  display: block;
  font-weight: 700;
  margin-top: 3px;
}

.record-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.record-actions a {
  align-items: center;
  display: inline-flex;
  font-weight: 700;
}

.bin-action-panel {
  background: #fafafa;
  border-top: 1px solid #eeeeee;
  padding: 16px;
}

@media (max-width: 992px) {
  .record-grid {
    align-items: start;
    grid-template-columns: 88px 1fr;
  }

  .record-meta,
  .record-actions {
    grid-column: 2;
  }
}
</style>
